export type HeatmapWidgetAxisParams = {
  min: number;
  max: number;
  step: number;
  name: string;
  unit: { id: number | null; abbreviation: string };
};

export type HeatmapZFilterParams = {
  min: number | null;
  max: number | null;
};

export type VisualMapAxisParams = Omit<HeatmapWidgetAxisParams, 'step' | 'min' | 'max'> & {
  analysisType: AnalysisType;
};

export enum HeatmapChartKey {
  ROP = 'rop',
  DENSITY = 'density',
  MSE = 'mse',
}

export type DrillingMode = 'load' | 'drop_off';

export enum ValueRangeKey {
  WOB = 'wob',
  DPRESS = 'dpress',
  RPM = 'rpm',
  RPMTOT = 'rpmtot',
}

export enum StepRangeKey {
  WOB = 'wob',
  DPRESS = 'dpress',
  RPM = 'rpm',
  RPMTOT = 'rpmtot',
}

export enum UnitOptionsKeys {
  WOB = 'wob',
  DPRESS = 'dpress',
  ROP = 'rop',
  MSE_BIT = 'mse_bit',
  MSE_SURFACE = 'mse_surface',
}

export enum IntervalsTypes {
  SECTIONS = 'sections',
  FORMATIONS = 'formations',
  DRILLING_ANALYSIS = 'drilling_analysis',
  STRAT_UNITS = 'strat_units',
  USER_DEFINED = 'user_defined',
}

export enum AnalysisTypeKey {
  ROP = 'rop',
  MSE_BIT = 'mseBit',
  MSE_SURFACE = 'mseSurface',
}

export enum ZFilterKey {
  ROTATION_ROP = 'rotationRop',
  ROTATION_MSE = 'rotationMse',
  SLIDE_ROP = 'slideRop',
  SLIDE_MSE = 'slideMse',
}

export enum AnalysisType {
  MEDIAN = 0.5,
  Q10 = 0.1,
  Q90 = 0.9,
  Q25 = 0.25,
  Q75 = 0.75,
}

export enum OperationRegimes {
  ROTATION = 'rotation',
  SLIDE = 'slide',
}
